<template>
  <div>
    <el-dialog
      title="订单地址确认"
      :visible.sync="visible"
      @close="close"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="order_info_tips">
        <img src="@/assets/img/order_info_tips.svg" alt="" />
        <span
          >请确认地图识别地址是否正确，如识别不正确，导入订单后会导致师傅空跑或是超区加价</span
        >
      </div>
      <div class="remark-add">
        <el-table
          empty-text="暂无数据"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          height="635"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="60" align="center">
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="客户姓名"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="customerPhone"
            label="客户电话"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="客户地址"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.address"
                placement="top"
              >
                <span>{{ scope.row.address }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="identifyAddress"
            label="地图识别地址"
            filter-placement="bottom"
            header-align="center"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color:
                    scope.row.address == scope.row.identifyAddress
                      ? '#909399'
                      : '#f75658',
                }"
                ><i
                  class="el-icon-warning-outline"
                  v-if="scope.row.address != scope.row.identifyAddress"
                ></i
                >{{ scope.row.identifyAddress }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="pickupAddress"
            label="提货地址"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="identifyPickupAddress"
            label="地图识别地址"
            header-align="center"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color:
                    scope.row.identifyPickupAddress == scope.row.pickupAddress
                      ? '#909399'
                      : '#f75658',
                }"
                ><i
                  class="el-icon-warning-outline"
                  v-if="
                    scope.row.identifyPickupAddress != scope.row.pickupAddress
                  "
                ></i
                >{{ scope.row.identifyPickupAddress }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="confirmLoading"
          >确认无误</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postAction } from "@/api/manage";

export default {
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      remark: "",
      visible: false,
      list: {},
      loading: false,
      confirmLoading: false,
    };
  },

  methods: {
    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    init(list) {
      this.tableData = list;
      this.visible = true;
    },
    // 备注弹窗关闭
    close() {
      this.list = [];
      this.visible = false;
    },
    // 保存
    submit() {
      this.$message.closeAll();
      if (!this.multipleSelection.length)
        return this.$message.error("至少选择一个订单提交");
      this.confirmLoading = true;
      postAction(
        "/order/api/order/order_batch_add",
        this.$qs.stringify({
          orderBatchIds: this.multipleSelection.map((i) => i.id).join(","),
        })
      )
        .then(({ data }) => {
          console.log(data);
          if (data.code == 0) {
            this.close();
            this.$confirm("可在'批量导入记录'中查看导入进度", "订单导入中", {
              confirmButtonText: "去查看",
              cancelButtonText: "取消",
            }).then(() => {
              this.$router.push({ path: "/user/batch/order" });
            });
          }
        })
        .finally(() => (this.confirmLoading = false));
    },
  },
};
</script>
<style lang="scss">
.el-tooltip__popper {
  background: #fff6e7 !important;
  color: #5e6066 !important;
  // width: 232px;
  max-width: 232px;
  line-height: 16px;
  .popper__arrow {
    display: none !important;
  }
}
#orderlist {
  &.remark_modal {
    .dialog-footer {
      & > .el-button {
        padding: 11px 18px !important;
        height: auto;
        width: auto;
      }
      & > .el-button:first-child {
        color: #5e6066 !important;
      }
    }
  }
}
</style>
<style lang='scss' scoped>
/deep/.remark-add {
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3455d3;
    border-color: #3455d3;
  }
  .el-checkbox {
    margin-top: 0;
  }
  .el-table-column--selection {
    text-align: center;
  }
  .cell {
    padding: 0 10px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    color: #5e6066;
  }
  .el-table__header-wrapper {
    .has-gutter {
      .el-table__cell {
        padding: 6px 0;
      }
    }
    height: 38px;
  }
  .el-table__body-wrapper {
    .el-table__cell {
      padding: 16px 0;
    }
  }
}
.order_info_tips {
  height: 40px;
  background: #fff6e7;
  border: 2px solid #ffd68a;
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 7px 15px;
  color: #5e6066;
  font-size: 12px;
  margin-bottom: 10px;

  img {
    margin-right: 10px;
    width: 26px;
    height: 26px;
  }
}
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover,
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #3455d3;
}

#orderlist.complaint /deep/ .complaint-img > span {
  display: flex;
  flex-wrap: wrap;
}

#orderlist.complaint .complaint-img /deep/ .ant-upload-list {
  width: auto !important;
}

#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
  border-radius: 2px;
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1152px !important;
    margin-top: 5vh !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

#orderlist /deep/.genjinupload {
  margin-top: 20px;

  .ant-upload.ant-upload-select-picture-card {
    width: 80px !important;
    height: 80px !important;
    margin-left: 0 !important;
  }

  .ant-upload-list {
    height: 80px !important;
  }

  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 80px !important;
    height: 80px !important;
    padding: 0;
  }
}
</style>
